<template>
  <div class="partner-tab-bulk-actions">
    <span v-if="selectedCount" class="partner-tab-bulk-actions__count">
      {{ selectedCount }} selected
    </span>
    <BittsDropdown
      :options="actionOptions"
      placement="bottomRight"
      @selection="handleSelection"
    >
      <template #prompt>
        <BittsButton
          data-testid="by-partners__actions-button"
          text="Actions"
          type="neutral"
          variant="outline"
          size="small"
          :right-icon="['fak', 'chevron-down']"
        />
      </template>
    </BittsDropdown>
  </div>
</template>

<script setup lang="ts">
import { BittsButton, BittsDropdown, type BittsIcon } from '@crossbeam/bitts';

import { computed } from 'vue';

const { selectedCount } = defineProps<{ selectedCount: number }>();

const emit = defineEmits<{
  'edit-tags': [];
  remove: [];
}>();

const NO_SELECTION_TOOLTIP = 'Select at least one partner first';

const ACTIONS = [
  {
    value: 'edit_tags',
    display: 'Edit tags',
    iconType: ['fak', 'tag'] as BittsIcon,
  },
  {
    value: 'remove',
    display: 'Remove partners',
    iconType: ['fak', 'delete'] as BittsIcon,
    danger: true,
  },
];

const actionOptions = computed(() =>
  ACTIONS.map((action) => ({
    ...action,
    disabled: !selectedCount,
    tooltip: selectedCount ? undefined : NO_SELECTION_TOOLTIP,
  })),
);

function handleSelection(option: { value: string; disabled?: boolean }) {
  if (option.disabled) return;
  if (option.value === 'edit_tags') emit('edit-tags');
  else if (option.value === 'remove') emit('remove');
}
</script>

<style scoped lang="pcss">
@reference "../../../../css/theme.css";
.partner-tab-bulk-actions {
  @apply flex items-center gap-6;
}
.partner-tab-bulk-actions__count {
  @apply text-sm text-neutral-text;
}
</style>
